export function isProfileComplete(user) {
  return Boolean(user?.name?.trim())
}
